<template>
  <div class="password-input">
    <input
      ref="input"
      :class="[statusType, size]"
      :type="isPasswordVisible ? 'text': 'password'"
      :autocomplete="newAutocomplete"
      :value="newValue"
      :maxlength="maxlength"
      v-bind="$attrs"
      class="input"
      @input="input"
      @blur="checkHtml5Validity() && $emit('blur', $event)"
      @focus="$emit('focus', $event)">
    <div @click="toggleField">
      <svg-icon :class="{'is-transparent': !isPasswordVisible}" name="eye"></svg-icon>
    </div>
  </div>
</template>

<script>

import '../../distribution/icons/eye';

import BuefyInput from 'Root/buefy/src/components/input/Input.vue';

export default {
  extends: BuefyInput,
  data() {
    return {
      isPasswordVisible: false
    };
  },
  methods: {
    toggleField() {
      this.isPasswordVisible = !this.isPasswordVisible;
    }
  }
};
</script>

<style lang="scss" scoped>
.password-input {
  position: relative;
  input {
    padding-right: 30px;
  }
  .svg-icon {
    position: absolute;
    top: 14px;
    right: 10px;
    cursor: pointer;

    /deep/ .fill {
      fill: var(--gray);
    }

    &.is-transparent {
      opacity: 0.4;
    }
  }
}
</style>
